import { ViewModel, View } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { ServerConnection } from "src/server/serverConnection";

export class WorkStationSelectorViewModel extends SelectorBaseViewModel<WorkStation> {
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    protected async loadData(): Promise<WorkStation[]> {
        let result = await ServerConnection.callServer('/Complex/ProductLineServices/GetAllProductLineWorkStations', {})
        return result.WorkStations.map(x => {
            let p = new WorkStation(this);
            p.id = x.Id;
            p.title = x.Name;
            return p;
        });
    }
}

export class WorkStation extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title; } private _title: string;
}